import { render, staticRenderFns } from "./Stagingbottom.vue?vue&type=template&id=5d0a4098&scoped=true&"
import script from "./Stagingbottom.vue?vue&type=script&lang=js&"
export * from "./Stagingbottom.vue?vue&type=script&lang=js&"
import style0 from "./Stagingbottom.vue?vue&type=style&index=0&id=5d0a4098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0a4098",
  null
  
)

export default component.exports